export const yesNoOptions = [
  { label: "yes", value: true },
  { label: "no", value: false },
];
